"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _smile = _interopRequireDefault(require("cccisd-icons/smile"));
var _wondering = _interopRequireDefault(require("cccisd-icons/wondering"));
var _round2 = _interopRequireDefault(require("lodash/round"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SummaryTable = function SummaryTable(props) {
  var _renderDataFace = function _renderDataFace(value) {
    if (value < props.targetScore) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          color: 'red'
        }
      }, /*#__PURE__*/_react["default"].createElement(_wondering["default"], {
        spaceRight: true
      })), value, "%");
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        color: '#3673b6'
      }
    }, /*#__PURE__*/_react["default"].createElement(_smile["default"], {
      spaceRight: true
    })), value, "%");
  };
  var columns = [{
    name: 'group.label',
    label: 'Group Name',
    sort: true
  }, {
    name: 'childRoles.metricspawn.assignmentProgressSummary.lastSessionHeld',
    label: 'Current Session',
    sort: true
  },
  // { name: 'lastSession', label: 'Date of Last Session', sort: true },
  {
    name: 'childRoles.metricspawn.assignmentProgressSummary.youthFidelityScoreCombinedAvg',
    label: 'Average Teen Adherence',
    sort: true,
    render: function render(_ref) {
      var value = _ref.value;
      return _renderDataFace((0, _round2["default"])(value));
    }
  }, {
    name: 'childRoles.metricspawn.assignmentProgressSummary.caregiverFidelityScoreCombinedAvg',
    label: 'Average Caregiver Adherence',
    sort: true,
    render: function render(_ref2) {
      var value = _ref2.value;
      return _renderDataFace((0, _round2["default"])(value));
    }
  }, {
    name: 'childRoles.metricspawn.assignmentProgressSummary.familyFidelityScoreCombinedAvg',
    label: 'Average Family Adherence',
    sort: true,
    render: function render(_ref3) {
      var value = _ref3.value;
      return _renderDataFace((0, _round2["default"])(value));
    }
  }];
  return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    rowKey: "group.groupId",
    query: props.query,
    graphqlVariables: {
      groupIds: props.filters.groupIds,
      startDate: props.filters.startDate,
      endDate: props.filters.endDate
    },
    columns: columns
    // render={tableProps => console.log(tableProps)}
  });
};
var _default = exports["default"] = SummaryTable;